import { useEffect } from 'react';
import { fetchContentCatalog } from '../utils/contentCatalog';

/** Warm the shared content catalog as soon as the app mounts. */
export default function ContentCatalogPrefetch() {
  useEffect(() => {
    fetchContentCatalog();
  }, []);
  return null;
}
